// Constantes de couleurs du glisser-déplacer / étirer d'un RDV (Prompt 13).
// Palette verte « saisi » + palette ambre/brique « conflit ». Aucun noir ni
// rouge vif dans cet effet. Centralisé ici pour rester la source unique.
export const DRAG_COLORS = {
  dragBg: "#d6ecc9",        // fond du RDV saisi
  dragBorder: "#5f8f73",    // bord 2px, repères, poignée active
  dragInk: "#1f3d31",       // texte du RDV saisi
  dragMeta: "#4b6b5a",      // ligne horaire
  dragTime: "#2f5d4a",      // heure (JetBrains Mono)
  dragTip: "#2f5d4a",       // fond de la bulle horaire (texte blanc)
  dragColumn: "#f1f8ec",    // fond de la colonne visée

  conflict: "#c86f4b",      // bord, bulle, repères en cas de conflit
  conflictBg: "#f6e3da",    // fond du RDV en conflit
  conflictColumn: "#fbf1ec", // fond de la colonne visée en conflit

  handleRest: "#c9ccd2",    // poignée d'étirement au repos
  pulseBg: "#e9f5e1",       // fond de la pulsation après dépôt
  pulseHalo: "rgba(95,143,115,.30)", // halo de la pulsation

  silBorder: "#b5b9c0",     // silhouette d'origine (pointillés)
  silBg: "rgba(243,242,238,.55)",
  silText: "#9aa0ab",

  bannerBg: "#2f5d4a",      // bandeau d'annulation
  bannerBtnBg: "#d6ecc9",
  bannerBtnInk: "#1f3d31",

  nowLine: "#dc2626",       // ligne de l'heure actuelle (prompt 15)
};
